class ParserContext extends Map<string, string> {}

export default ParserContext;
